import type { Piece } from '../func';
import { parse } from '../func';

function piece(
  start: number,
  end: number,
  openLeft: boolean,
  openRight: boolean,
  src: string,
): Piece {
  return {
    interval: { start, end, openLeft, openRight },
    node: parse(src).node,
  };
}

export const PIECEWISE_PRESETS: Record<string, Piece[]> = {
  heaviside: [piece(-Infinity, 0, true, true, '0'), piece(0, Infinity, false, true, '1')],
  relu: [piece(-Infinity, 0, true, false, '0'), piece(0, Infinity, true, true, 'x')],
  step: [
    piece(-Infinity, -1, true, true, '-1'),
    piece(-1, 1, false, false, '0'),
    piece(1, Infinity, true, true, '1'),
  ],
  tent: [piece(-1, 0, false, true, 'x + 1'), piece(0, 1, false, false, '1 - x')],
};
